import React, { forwardRef } from 'react'
import { SvgIcon, SvgIconProps } from '@mui/material'

const Vital = forwardRef<SVGSVGElement, SvgIconProps>(
  function Vital(props, ref) {
    return (
      <SvgIcon ref={ref} {...props}>
        <path
          d="M14.5483064,1.43876135 C13.6236394,0.528439458 12.3959907,0.0112532857 11.0984121,0.0112532857 C9.97782781,0.0112532857 8.87460148,0.386259654 8.00350228,1.10001369 C5.88746751,-0.613281493 2.79237984,-0.291949427 1.08557318,1.83189707 C-0.177431385,3.40160278 -0.355279145,5.61390125 0.640953865,7.36277707 L3.02376001,7.36277707 L5.49549065,3.06205215 L7.11419145,7.98731185 L8.92806257,4.75721797 L10.4578394,7.38008561 L11.9160502,7.3807833 C12.2182494,7.3807833 12.449594,7.61289611 12.449594,7.91609882 C12.449594,8.21930154 12.2182494,8.45141435 11.9160502,8.45141435 L9.85265843,8.45141435 L8.94534939,6.91655768 L6.84727726,10.6100564 L5.21121851,5.66748812 L3.62865642,8.433285 L1.45837803,8.433285 L8.00336,15 L14.5837337,8.39777573 C16.4865288,6.47046141 16.4692776,3.34778751 14.5483028,1.43867392 L14.5483064,1.43876135 Z"
          transform="translate(4, 4)"
        />
      </SvgIcon>
    )
  },
)

export default Vital
